import { styled } from '@mui/material'

export const OrganisationMenuItemButtonWrapper = styled('button')(({ theme }) => ({
  width: '100%',
  display: 'flex',
  justifyContent: 'space-between',
  gap: 12,
  padding: 12,
  paddingLeft: 16,
  border: 'none',
  cursor: 'pointer',
  backgroundColor: 'transparent',
  transition: 'background-color 0.15s',
  borderTop: `${theme.strokeWidth.default} solid ${theme.palette.border.strong}`,
  position: 'relative',

  '&:hover': {
    backgroundColor: theme.palette.bg.surface.subtle,
  },

  '&[data-is-first-search-result=true]': {
    backgroundColor: theme.palette.bg.surface.subtle,

    '&:after': {
      content: '"Enter ↵"',
      fontSize: 10,
      fontWeight: 'bold',
      color: theme.palette.text.muted,
      lineHeight: 1,
      padding: 3,
      position: 'absolute',
      right: 0,
      top: 0,
      transform: 'translateY(-25%) translateX(-10%)',
      backgroundColor: theme.palette.bg.surface.subtle,
      borderStyle: 'solid',
      borderWidth: theme.strokeWidth.default,
      borderColor: theme.palette.border.strong,
      borderRadius: 3,
      boxShadow: ' rgba(0, 0, 0, 0.15) 1px 1px 1px',
    },
  },
}))
